import React, { useEffect,  } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../Components/Footer/footer";
import LandingHero from "../Components/Landing/hero";
import AboutKryzen from "../Components/Landing/about";
import ServicesSection from "../Components/Landing/services";
import WhyChooseKryzen from "../Components/Landing/why";
import NewsletterSection from "../Components/Landing/newsletter";
import KryzenSocialCard from "../Blog/kryzen_social_media";
import LatestPosts from "../Blog/latest_posts";
import RandomPosts from "../Blog/random_posts";
import {
  Adcards,
  AgriSubsidyCard,
  FarmSetupCard,
  GalleryCarouselCard,
  HydroponicWebinarCard,
  SharkTankKryzenVideo,
} from "../Components/Sidebar Banner/sidebarBanner";

function LandingPage() {
  
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Kryzen Info",
      alternateName: "Kryzen Biotech",
      parentOrganization: {
        "@type": "Corporation",
        name: "Kryzen Biotech Pvt. Ltd.",
        url: "https://kryzen.com",
      },
      url: "https://kryzen.info",
      logo: "https://kryzen.com/og-image.jpg",
      description:
        "Kryzen Info is the media & knowledge division of Kryzen Biotech, providing hydroponics trends, innovations, subsidies, farm setup guidelines & modern farming education.",
      sameAs: [
        "https://facebook.com/kryzenbiotech",
        "https://www.instagram.com/kryzen_biotech",
        "https://in.linkedin.com/company/kryzen",
        "https://www.youtube.com/@kryzen",
      ],
    });

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Kryzen Info | India's Hydroponics Trends, AgriTech News & Smart
          Farming Updates
        </title>

        <meta
          name="description"
          content="Kryzen Info is the media & knowledge division of Kryzen Biotech, providing hydroponics trends, innovations, subsidies, modern farming insights, and agri-tech updates across India."
        />
        <meta
          name="keywords"
          content="hydroponics india, modern farming, agritech india, kryzen biotech, hydroponic trends, smart farming india, hydroponic subsidies, greenhouse farming india, hydroponic webinar"
        />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://kryzen.info/" />

        <meta property="og:site_name" content="Kryzen Info" />
        <meta
          property="og:title"
          content="Kryzen Info - India's Hydroponics & Smart Farming Knowledge Hub"
        />
        <meta
          property="og:description"
          content="Daily hydroponics trends, AgriTech innovations, subsidies, greenhouse education & farm automation insights."
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763957144/kryzen_info-logo_iudzc9.png"
        />
        <meta property="og:url" content="https://kryzen.info" />
        <meta property="og:type" content="website" />

        {/* Twitter */}

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Kryzen Info - Hydroponics News & Innovations"
        />
        <meta
          name="twitter:description"
          content="India’s fastest-growing modern farming knowledge Hub."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763957144/kryzen_info-logo_iudzc9.png"
        />
      </Helmet>

      <div className="page-wrapper container">
        <LandingHero
          title="Empowering the Future of Smart & Sustainable Farming"
          subtitle="Kryzen Biotech is India’s leading hydroponics and agri-tech company delivering end-to-end solutions — from hydroponic farm development and automation systems to AI-powered farm management, commercial training, and advanced agri tools."
          buttonText="🌿 Join Newsletter"
          buttonLink="#newsletter"
          background="bg-light"
        />
        <div className="">
          <div className="row ">
            <div className="col-12 col-md-8 col-lg-8 border-0 border-md-end border-md-1 border-dark">
              <ServicesSection />
            </div>

            {/* Sidbebar */}
            <div className="col-12 col-md-4 col-lg-4 mt-4 mt-md-0 mt-lg-0  sidebar px-4 px-md-0 px-lg-0">
              <Adcards />
              <div>
                <h2 className="mt-4 fs-1">Trending Articles</h2>

                <RandomPosts />
              </div>
              <div>
                <KryzenSocialCard />
              </div>
              <div>
                <SharkTankKryzenVideo />
              </div>

              <div>
                <GalleryCarouselCard />
              </div>

              <div className="mt-2">
                <AgriSubsidyCard />
              </div>
              <div>
                <HydroponicWebinarCard />
              </div>
              <div>
                <FarmSetupCard />
              </div>
            </div>
          </div>
        </div>
        <hr className="border border-1 border-dark" />
        <LatestPosts />

        <AboutKryzen />
        <WhyChooseKryzen />
        <NewsletterSection />
        <Footer />
      </div>
    </>
  );
}

export default LandingPage;
